import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ethers, BigNumber } from "ethers";
import { bigNumAsInt } from "./bigNumAsInt";
import useInterval from "./useInterval";
import WLMintInputs from "./WLMintInputs";
import { useMetamask } from "./UseMetamask";
import Contract from "../AppCustomisation/mainContractABI.json";
import WhitelistContract from "../AppCustomisation/whitelistContractABI.json";
import { min } from "ramda";
import {
  contractAddress,
  whitelistAddress,
  price,
} from "../AppCustomisation/dAPPCustomisation";
import { HeroP2 } from "./MintInputsElements";

const WhitelistMint = () => {
  const [totalTickets, setTotalTickets] = useState(0);

  const { account, signer, provider } = useMetamask();

  const handleFetchIsHoldingTickets = async () => {
    const contract = new ethers.Contract(
      whitelistAddress,
      WhitelistContract.abi,
      provider
    );
    try {
      const totalTickets = await contract.balanceOf(account);
      setTotalTickets(bigNumAsInt(totalTickets));
      console.log(bigNumAsInt(totalTickets));

    } catch (err) {
      console.log(err);
    }
  };

  const handleMint = async (mintAmount) => {
    const contract = new ethers.Contract(contractAddress, Contract.abi, signer);
    try {
      const response = await contract.whitelistMint(
        BigNumber.from(mintAmount),
        {
          value: ethers.utils.parseEther((price * mintAmount).toString()),
        }
      );
      console.log("response: ", response);
      toast.success('Success! Check Metamask for confirmation', {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        });
    } catch (err) {
      console.log("error: ", err);
      toast.error('Something went wrong! You are likely not whitelisted', {
        position: "bottom-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        });
    }
  };

  useInterval(() => {
    handleFetchIsHoldingTickets();
  }, 5000);

  return (
    <>
      {Boolean(totalTickets) ? <WLMintInputs maxMintAmount={5} handleMint={handleMint} /> : <HeroP2>You are not whitelisted</HeroP2>}
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default WhitelistMint;
